module.exports = "/_next/static/images/all_recommendations_mobile-fbce5689782dbb8036586ec7565e43e3.png";